import { UpdatePopup, UpdatePopupResponse } from "./";
import { Api } from "../../../../services/Api";
import { Utility } from "../../../../utils";

export class UpdateClassPopup extends UpdatePopup<{}> {

    public doUpdatePromise(abstractId?: number, classificationId?: number): Promise<UpdatePopupResponse> {
        if (!abstractId || abstractId === 0)
            return Utility.failedPromise("Abstract ID cannot be undefined or zero.");

        return new Promise((resolve, reject) => {
            const updatePromise = this.props.api.put<any>(Api.endpoints.admin.abstract.abstractClassification, {
                body: JSON.stringify({
                    abstractIds: [abstractId],
                    classificationId,
                }),
            });

            updatePromise.then(
                (result) => {
                    if (result.isSuccess && result.data)
                        resolve({ abstractId: result.data.abstractIds[0], selectedId: result.data.classificationId });
                    else
                        reject(result.errors.join("; "));
                },
                (err) => reject(err),
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/list/components/UpdateClassPopup.tsx